import HashtagsContainer from "@components/HashtagsContainer/Hashtags.container";
import { flexColumn, transitionMixin } from "@components/mixins";
import ResponsiveImage from "@components/ResponsiveImage/ResponsiveImg.component";
import { useAnimationLayout } from "@utils/animationUtils";
import { getAllSizesPNG } from "@utils/helpers";
import { useRef } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { animationLayout } from "./animationLayout";

const PreviewContainer = styled.div`
    ${flexColumn};
    justify-content: flex-start;
    max-width: 320px;
    min-height: 520px;
    height: auto;
    margin: 30px 15px;

    /* Initial state for animated elements to prevent flicker */
    > a {
        opacity: 0;
    }

    ${({ big }) =>
        big
            ? css`
                  max-width: unset;
                  width: 620px;

                  @media screen and (max-width: 1250px) {
                      width: 420px;
                  }

                  @media screen and (max-width: 1050px) {
                      max-width: 400px;
                  }
              `
            : ""};

    @media screen and (max-width: 1050px) {
        max-width: 400px;
    }

    @media screen and (max-width: 560px) {
        margin: 15px;
        height: 100%;
        max-height: unset;
        min-height: unset;
    }
`;

const ImageContainer = styled.div`
    width: 100%;
    overflow: hidden;

    img {
        width: 100%;
        height: 450px;
        object-fit: cover;
        ${transitionMixin("1s")};
    }

    &:hover {
        img {
            transform: scale(1.03);
        }
    }

    @media screen and (max-width: 560px) {
        height: 100%;

        img {
            height: 100%;
            max-height: 320px;
        }
    }
`;

export const ContentContainer = styled.div`
    ${flexColumn};
    align-items: flex-start;
    opacity: 0; /* Initial state to prevent flicker */

    p {
        font-family: ${({ theme }) => theme.ff.Cormorant};
        font-size: 1.5rem;
        color: ${({ theme }) => theme.colors.dark_grey};
        line-height: 160%;
    }
`;

const Title = styled.h4`
    margin-top: 15px;
    text-transform: uppercase;
    padding-bottom: 15px;
    overflow: hidden;

    @-moz-document url-prefix() {
        position: relative;
    }

    a {
        position: relative;
        text-decoration: none;
        color: inherit;

        @-moz-document url-prefix() {
            position: static;
        }

        &::before {
            content: "";
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: ${({ theme }) => theme.colors.black};
            transform: translateX(-100%);
            ${transitionMixin("0.4s")};

            @-moz-document url-prefix() {
                bottom: 10px;
            }
        }

        &:hover {
            &::before {
                transform: translateX(0);
            }
        }
    }
`;

const ArticlePreview = ({ big, slug, title, lead, imgSet }) => {
    const { small, medium, large } = getAllSizesPNG(imgSet);

    const containerRef = useRef();

    useAnimationLayout(containerRef, animationLayout);

    return (
        <PreviewContainer big={!!big} ref={containerRef}>
            <Link to={`/artykuly/${slug}`}>
                <ImageContainer>
                    <ResponsiveImage
                        small={small}
                        medium={medium}
                        large={large}
                        alt={title}
                    />
                </ImageContainer>
            </Link>
            <ContentContainer>
                <Title>
                    <Link to={`/artykuly/${slug}`}>{title}</Link>
                </Title>
                <p>{lead}</p>
                <HashtagsContainer hashtags={["wyprawka", "dziecko"]} />
            </ContentContainer>
        </PreviewContainer>
    );
};

export default ArticlePreview;
